<template>
<div>
    <b-card style="width:1000px;margin-left:230px;margin-top:50px" header="Update User ID">
 
  <v-form  ref="form" v-model="valid" lazy-validation>
<!-- <h3 > <b></b> </h3>  -->
    <v-row style="margin-left:190px">
      <v-col >
        <v-text-field v-model="form.serialNo" :rules="serialnumberRules" label="Enter Serial Number" required style="width:500px;"></v-text-field>
        <v-text-field v-model="form.mobileNo" :rules="mobilenumberRules" label="Enter Mobile Number" required style="width:500px"></v-text-field>
      </v-col>
    </v-row>
    <v-btn :disabled="!valid" class="primary mr-4" @click="handleSubmit" style="color:white">Submit</v-btn>
  </v-form>
    </b-card>
</div>
</template>
<script>
import { extractError } from "../../utils/error";
import { updateuserid } from "@/services/updateuserid";

export default {
  data: () => ({
    form: {
      serialNo: "",
      mobileNo: "",
    },

  
   serialnumberRules: [v => !!v || "Serial Number is Required"],
    mobilenumberRules: [v => !!v || "Mobile Number is required"],
  
    valid: true,
    select: null
  }),

  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        this.snackbar = true;
      }
    },
    async handleSubmit() {
      try {
        const hasError = this.validate();
        if (hasError) {
          this.$toasted.error(hasError, {
            duration: 2000
          });
          return;
        }
        const { form, ...payload } = this.form;

        const result = await updateuserid(payload);
        //const { response: { userID: userId }  } = result;
        payload[form] = true;
        this.$router.push({
          name: "Updateuserid",
          params: {}
        });
        this.$toasted.success("Successfully created", {
          duration: 2000
        });
      } catch (err) {
        const message = extractError(err);
        this.$showError(message);
      }
    }
  }
};
</script>
<style scoped>
.card-header {
    padding: 0.75rem 1.25rem;
    margin-bottom: 0;
    background-color: rgba(0, 0, 0, 0.03);
    border-bottom: 1px solid rgba(0, 0, 0, 0.125);
    background: linear-gradient( 
225deg, #59065d 0%, #8d0b93 50%, #061d48 100% );
    color: white;
}
/* .forum{
    margin-left:3 rem !important;
} */
</style>